module.exports = __webpack_public_path__ + "static/media/AMCActive.066c0f67.svg";